/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheckList
 */
export interface CheckList {
    readonly id: number;
    readonly order: boolean;
    readonly lead_id: number;
    readonly title: string;
    readonly text: string;
    isChecked: boolean;
    readonly updatedAt: string
}

export function CheckListFromJSON(json: any): CheckList {
    return CheckListFromJSONTyped(json, false);
}

export function CheckListFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckList {
    if ((json === undefined) || (json === null)) {
        return json;
    }

    return {
        id: !exists(json, 'id') ? undefined : json['id'],
        order: !exists(json, 'order') ? undefined : json['order'],
        lead_id: !exists(json, 'lead_id') ? undefined : json['lead_id'],
        title: !exists(json, 'title') ? undefined : json['title'],
        text: !exists(json, 'text') ? undefined : json['text'],
        isChecked: !exists(json, 'isChecked') ? undefined : json['isChecked'],
        updatedAt: !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
    };
}

export function CheckListToJSON(value: any | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        order: value.order,
        lead_id: value.lead_id,
        title: value.title,
        text: value.text,
        isChecked: value.isChecked,
    };
}


